import { __ } from '@wordpress/i18n';
import {VayuBlocksSelectControl, VayuBlocksToggleControl} from '@vayu-blocks';
import { FormTokenField } from '@wordpress/components';


const options = [
    { label: 'None', value: 'none' },
    { label: 'User State', value: 'user_state' },
    { label: 'User Role', value: 'user_role' },
    { label: 'Browser', value: 'browser' },
    { label: 'Operating System', value: 'os' },
    { label: 'Day', value: 'day' },
    { label: 'Date', value: 'date' },
    { label: 'Time', value: 'time' },
];

const user_role_options = ['Administrator', 'Editor', 'Author', 'Contributor', 'Subscriber',  'Customer',  'Shop Manager',  'Product Compare Role'];

const browser_options = [  'Google Chrome', 'Mozilla Firefox', 'Safari', 'Microsoft Edge', 'Opera'];

const os_options = ['Windows', 'IOS' , 'Linux', 'Android', 'Mac OS', 'SunOS' , 'Open BSD'];

export const VayuBlocksDisplayCondition = ({discond, onChange}) => {

    const handleSelect = (value) => {
        const updatedValue = {
            ...discond.value,
            cond:value
        }

        onChange(discond.key, updatedValue);
    }

    const handleChange = (parent, child, value) => {

        const updatedValue = {
            ...(discond.value || {}),
            [parent]: {
                ...(discond.value?.[parent] || {}),
                [child]: value
            }
        };


        onChange(discond.key, updatedValue);
    }

    const handleformChange = (parent, value) => {

        const updatedValue = {
            ...(discond.value || {}),
            [parent]: value
        };

        onChange(discond.key, updatedValue);
    }

    const handleclearChange= () => {

        const updatedValue = {
            ...(discond.value || {}),
            day: {}
        };

        onChange(discond.key, updatedValue);
    }

    const handledateclearChange= () => {

        const updatedValue = {
            ...(discond.value || {}),
            date: {}
        };

        onChange(discond.key, updatedValue);
    }

    const handletimeclearChange= () => {

        const updatedValue = {
            ...(discond.value || {}),
            time: {}
        };

        onChange(discond.key, updatedValue);
    }
    
  return (
    <>

        <VayuBlocksSelectControl 
            label= {__('Display Conditions', 'vayu-blocks')}
            value= {discond.value?.cond || 'none'}
            options= {options}
            onChange={(value) => handleSelect(value)}
        />

        {discond.value?.cond === 'user_state' && (
            <>

                <VayuBlocksToggleControl 
                    label={__('Hide From Logged In Users', 'vayu-blocks')}
                    checked = {discond.value?.user_state?.loggedIn}
                    onChange={(value) => handleChange('user_state', 'loggedIn', value)}
                />

                <VayuBlocksToggleControl 
                    label={__('Hide From Logged Out Users', 'vayu-blocks')}
                    checked = {discond.value?.user_state?.loggedOut}
                    onChange={(value) => handleChange('user_state', 'loggedOut', value)}
                />
            
            </>
        )}
    
        {discond.value?.cond === 'user_role' && (
            <div className="vb-form-token-display-doncdition">
                <FormTokenField
                    label={__('Hide for User Role', 'vayu-blocks')}
                    value = {discond.value?.user_role}
                    suggestions={user_role_options}
                    onChange={(value) => handleformChange('user_role', value)}
                    __experimentalExpandOnFocus={true}
                    __next40pxDefaultSize={true}
                    __nextHasNoMarginBottom={true}
                   __experimentalValidateInput={(input) => user_role_options.some(option => option === input)}
                />
            </div>
        )}

        {discond.value?.cond === 'browser' && (
            <div className="vb-form-token-display-doncdition">
                <FormTokenField
                    label={__('Hide for Browser', 'vayu-blocks')}
                    value = {discond.value?.browser}
                    suggestions={browser_options}
                    onChange={(value) => handleformChange('browser', value)}
                    __experimentalExpandOnFocus={true}
                    __next40pxDefaultSize={true}
                    __nextHasNoMarginBottom={true}
                   __experimentalValidateInput={(input) => browser_options.some(option => option === input)}
                />
            </div>
        )}

        {discond.value?.cond === 'os' && (
            <div className="vb-form-token-display-doncdition">
                <FormTokenField
                    label={__('Hide for Operating System', 'vayu-blocks')}
                    value={discond.value?.os}
                    suggestions={os_options}
                    onChange={(value) => handleformChange('os', value)}
                    __experimentalExpandOnFocus={true}
                    __next40pxDefaultSize={true}
                    __nextHasNoMarginBottom={true}
                   __experimentalValidateInput={(input) => os_options.some(option => option === input)}
                />
            </div>
        )}

        {discond.value?.cond === 'day' && (
            <div style={{ border: '1.5px solid #ccc',borderRadius: '8px', backgroundColor: '#f9f9f9', padding: '10px'}}>
                <p style={{ fontWeight: '600', marginBottom: '10px' }}>Select days you want to disable:</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px 20px' }}>
                    {[
                        { key: 'sunday', label: 'Sun' },
                        { key: 'monday', label: 'Mon' },
                        { key: 'tuesday', label: 'Tue' },
                        { key: 'wednesday', label: 'Wed' },
                        { key: 'thursday', label: 'Thu' },
                        { key: 'friday', label: 'Fri' },
                        { key: 'saturday', label: 'Sat' },
                    ].map((day) => {
                        const isSelected = discond.value?.day?.[day.key];
                        return (
                            <button
                                key={day.key}
                                type="button"
                                onClick={() => handleChange('day', day.key, !isSelected)}
                                style={{
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    border: '1px solid #ccc',
                                    backgroundColor: isSelected ? '#0d6efd' : '#fff',
                                    color: isSelected ? '#fff' : '#333',
                                    cursor: 'pointer',
                                    transition: 'all 0.2s',
                                    fontWeight: '500',
                                }}
                            >
                                {day.label}
                            </button>
                        );
                    })}
                </div>

                <button className="vayu-button-clear-all-btn" onClick={() => handleclearChange()}>
                    Clear All
                </button>

            </div>
        )}

        {discond.value?.cond === 'date' && (
            <div className="vayu-date-container-dis">
                <div className="vayu-date-field-dis">
                <label htmlFor="start-date" className="vayu-date-label-dis">
                    {__('Start Date', 'vayu-blocks')}
                </label>
                <input
                    id="start-date"
                    type="date"
                    value={discond.value?.date?.start || ''}
                    max={discond.value?.date?.end || undefined}  // Start date can't be after End date
                    onChange={(e) => handleChange('date', 'start', e.target.value)}
                    className="vayu-date-input-dis"
                />
                </div>
                <div className="vayu-date-field-dis">
                <label htmlFor="end-date" className="vayu-date-label-dis">
                    {__('End Date', 'vayu-blocks')}
                </label>
                <input
                    id="end-date"
                    type="date"
                    value={discond.value?.date?.end || ''}
                    min={discond.value?.date?.start || undefined}  // End date can't be before Start date
                    onChange={(e) => handleChange('date', 'end', e.target.value)}
                    className="vayu-date-input-dis"
                />
                </div>

                <button style={{marginTop:'unset'}} className="vayu-button-clear-all-btn" onClick={() => handledateclearChange()}>
                    Clear All
                </button>
            </div>
        )}

        {discond.value?.cond === 'time' && (
            <div className="vayu-date-container-dis">
                <div className="vayu-date-field-dis">
                    <label htmlFor="start-time" className="vayu-date-label-dis">
                        {__('Start Time', 'vayu-blocks')}
                    </label>
                    <input
                        id="start-time"
                        type="time"
                        value={discond.value?.time?.start || ''}
                        max={discond.value?.time?.end || undefined} // Start time can't be after end time
                        onChange={(e) => handleChange('time', 'start', e.target.value)}
                        className="vayu-date-input-dis"
                    />
                </div>

                <div className="vayu-date-field-dis">
                    <label htmlFor="end-time" className="vayu-date-label-dis">
                        {__('End Time', 'vayu-blocks')}
                    </label>
                    <input
                        id="end-time"
                        type="time"
                        value={discond.value?.time?.end || ''}
                        min={discond.value?.time?.start || undefined} // End time can't be before start time
                        onChange={(e) => handleChange('time', 'end', e.target.value)}
                        className="vayu-date-input-dis"
                    />
                </div>

                <button style={{ marginTop: 'unset' }} className="vayu-button-clear-all-btn" onClick={() => handletimeclearChange()}>
                    Clear All
                </button>
            </div>
        )}

    </>
  )
}